import React from 'react'
import { TeamProvider } from './TeamContext'
import { NewsProvider } from './NewsContext'
import { ListingsProvider } from './ListingsContext'
import { HomeSectionsProvider } from './HomeSectionsContext'

const providers = [
  ListingsProvider,
  NewsProvider,
  TeamProvider,
  HomeSectionsProvider
]

// Compose all domain providers into a single app-level provider
export default function DataProvider ({ children }) {
  return providers.reduceRight(
    (tree, Provider) => <Provider>{tree}</Provider>,
    children
  )
}
